import { apiRequest } from "../apiRequest";

const ALLOWED_PHONE_FIELDS = new Set(["phone", "second_phone"]);

export const startLeadCall = async (leadId, phoneField = "phone") => {
    const normalizedPhoneField = ALLOWED_PHONE_FIELDS.has(phoneField)
        ? phoneField
        : "phone";

    const payload = await apiRequest(`/admin/lead/leads/${leadId}/call`, {
        method: "POST",
        body: {
            phone_field: normalizedPhoneField,
        },
        defaultErrorMessage: "Failed to start lead call.",
        notifyOnError: false,
    });

    if (Number(payload?.success) !== 1) {
        throw new Error("Failed to start lead call.");
    }

    return payload;
};
